<ng-container *transloco="let t">
  <div class="flex flex-col gap-6">
    <div class="flex flex-col gap-2">
      <label class="font-medium" for="termination-date">
        {{ t("app.organization-service-details.deactivateDialog.terminationDateLabel") }}
      </label>
      <p-datepicker
        inputId="termination-date"
        [(ngModel)]="terminationDate"
        [minDate]="earliestTerminationDate"
        [showIcon]="true"
        [showOnFocus]="false"
        appendTo="body"
        styleClass="w-full"
      />
      <small class="text-color-secondary">
        {{ t("app.organization-service-details.deactivateDialog.terminationDateDescription") }}
      </small>
    </div>

    <p class="font-semibold">
      {{ t("app.organization-service-details.deactivateDialog.warning") }}
    </p>

    <div class="flex justify-end gap-3">
      <p-button [label]="t('app.common.cancel')" severity="secondary" [outlined]="true" (onClick)="cancel()" />
      <p-button
        [label]="t('app.organization-service-details.manageSection.actions.deactivate')"
        severity="danger"
        (onClick)="confirm()"
      />
    </div>
  </div>
</ng-container>
